export default {
    namespaced: true,

    state: {
        entity: {},
    },

    mutations: {
        setEntity(state, data) {
            state.entity = data;
        },

        logOut(state) {
            state.entity = {};
        },
    },
};
